import ManualTradeChart from './ManualTradeChart';

export default ManualTradeChart;
